


























































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaintervento } from '@/data/models/tipologiaintervento.model';
import { Tipologiaservizio } from '@/data/models/tipologiaservizio.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class EditTipologiaintervento extends Vue {
	@Prop() tipologiaintervento?: Tipologiaintervento;

	@Inject('CrudService') tipologiainterventoCrudService!: CrudService<Tipologiaintervento>;

	newTipologiaintervento!: Tipologiaintervento;
	tipoServizioList: Tipologiaservizio[] = [];
	tipoServizioClass: ClassType<Tipologiaservizio> = Tipologiaservizio;
	tipoServizioValue: string = 'id';
	tipoServizioLabel: string = 'name';

	loading: boolean = false;

	constructor() {
		super();
		this.newTipologiaintervento = new Tipologiaintervento();
	}

	beforeMount() {
		if (this.tipologiaintervento) {
			if (this.tipologiaintervento.id) {
				this.newTipologiaintervento = cloneDeep(this.tipologiaintervento);
			} else {
				this.newTipologiaintervento = new Tipologiaintervento();
			}
		}
	}

	submit() {
		this.$emit('submit', this.newTipologiaintervento);
	}

	get color(): any {
		return {
			hex: this.newTipologiaintervento.color || '',
		};
	}

	set color(value: any) {
		this.$set(this.newTipologiaintervento, 'color', value.hex);
	}

}
